import React from "react";

import {
  Divider,
  Grid,
  Typography,
  Button
} from "@material-ui/core";

export default function CreditFieldGroupPersonWizard(
  {
    renderCreditField,
    creditFunctions,
    setMetafields,
    index,
  }) {

  const copyAdress = (fromIndex, toIndex) => {
    const fromFields = [
      "__person" + fromIndex + "__postleitzahl",
      "__person" + fromIndex + "__ort",
      "__person" + fromIndex + "__strasse",
      "__person" + fromIndex + "__hausnummer",
    ];


    setMetafields(fields => {
      fields.forEach((metafield) => {
        if (fromFields.includes(metafield.meta_key)) {
          let value = creditFunctions.getFirstValueByMetaKey(metafield.meta_key);
          const newMetaKey = metafield.meta_key.replace("__person" + fromIndex + "__", "__person" + toIndex + "__");
          // find the metafield with the new meta key
          const newMetafield = fields.find((field) => field.meta_key === newMetaKey);
          if (newMetafield) {
            // set the value of the new metafield
            fields = creditFunctions.setMetafieldValue(fields, newMetafield, value);
          }
        }
      });
      return [...fields];
    });

  };


  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h5">Kreditnehmer {index}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__anrede", 6, 2)}
      {renderCreditField("__person" + index + "__vorname", 6, 5)}
      {renderCreditField("__person" + index + "__nachname", 6, 5)}
      {renderCreditField("__person" + index + "__postleitzahl", 4, 2)}
      {renderCreditField("__person" + index + "__ort", 8, 4)}
      {renderCreditField("__person" + index + "__strasse", 8, 4)}
      {renderCreditField("__person" + index + "__hausnummer", 4, 2)}
      {renderCreditField("__person" + index + "__kontakt_mobil", 6, 4)}
      {renderCreditField("__person" + index + "__kontakt_email", 6, 4)}
      {index == 2 &&
        <Grid item xs={12} md={4}>
          <Button
            variant="text"
            onClick={() => {
              copyAdress(1, 2);
            }}
          >
            Adresse von Kreditnehmer 1 kopieren
          </Button>
        </Grid>
      }
      {index == 4 &&
        <Grid item xs={12} md={4}>
          <Button
            variant="text"
            onClick={() => {
              copyAdress(3, 4);
            }}
          >
            Adresse von Kreditnehmer 3 kopieren
          </Button>
        </Grid>
      }
    </>
  );
}
